import React, { useState,useEffect} from "react";
import { Box, Button, Select, Grid, FormControl, Typography, InputLabel, MenuItem, useMediaQuery, Card, CardContent, TableBody, Paper, TableCell, TableHead, TableRow, CardActionArea, Stack } from '@mui/material';
import { useNavigate, Link, useLocation } from 'react-router-dom';
import DefaultLayout from '../../../Components/DefaultLayout';
import Backdrop from '@mui/material/Backdrop';
import Freez from '../../../Components/Loader/Loader'
import { useDispatch } from 'react-redux';
import { fetchData,postData, postFormData } from '../../../redux/apiSlice';
import config from '../../../AppConfig';
const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

function FundingShotInfo(props) {
    const dispatch = useDispatch();
    const location = useLocation();
    const navigate = useNavigate();
    const fundingPartnerData = location.state?.data;
    const fundingPartnerId = location.state?.partnerId;
    const [fundingPartner, setFundingPartner] = useState([]);
    const [selectedPartner, setSelectedPartner] = useState(''); 
    const [fundingPartnerDetail, setFundingPartnerDetail] = useState([]);
    const [freez, setFreez] = React.useState(false);
    const handleFreezStop = () => {
        setFreez(false);
    };
    const handleFreezStart = () => {
        setFreez(true);
    };
    const isMobile = useMediaQuery('(max-width:600px)');

    useEffect(() => {
        if(fundingPartnerData == 1){
            getFundingSnapshotPartner();
        }else{
            getFundingSnapShotPartnerDetails(fundingPartnerId);
        }
        
    }, []);

    const getFundingSnapshotPartner = async () => {
        handleFreezStart();
        const apiUrl = '/fundingSnapshotPartner';
        const res = await dispatch(fetchData(apiUrl)).unwrap();
        if (res) {
            setFundingPartner(res.data);
            setSelectedPartner(res.data[1].id);
            getFundingSnapShotPartnerDetails(res.data[1].id);
            handleFreezStop();
        }
    }

    const getFundingSnapShotPartnerDetails = async (id) => {
         handleFreezStart();
        const apiUrl = '/fundingSnapShotPartnerDetails/'+id;
        const res = await dispatch(fetchData(apiUrl)).unwrap();
        if (res) {
            setFundingPartnerDetail(res.data);
            handleFreezStop();
        }
    }

    const handlePartnerChange = (event) => {
        setSelectedPartner(event.target.value);
        getFundingSnapShotPartnerDetails(event.target.value);
    };
    function ContentLayout() {
        return (
            <>
            <Grid container  item lg={12} md={12} sm={12} xs={12}>
                <Typography variant="h4"><b><img
                    src={require("../../../assets/images/back.png")}
                    alt="Back"
                    onClick={() => navigate(-1)}
                    style={{ cursor: 'pointer' }}
                /> Funding Partners</b></Typography></Grid>
                <Grid container item lg={4} md={4} sm={12} xs={12} mt={2}>
                    {fundingPartnerData == 1 && (
                    <FormControl fullWidth size='small'>
                        <InputLabel id="demo-multiple-name-label">Select Your Funding Partner</InputLabel>
                        <Select
                        labelId="demo-multiple-name-label"
                        name='description'
                        id='description'
                        label="Select Your Funding Partner"
                        value={selectedPartner}
                        onChange={handlePartnerChange}
                        MenuProps={MenuProps}
                        >
                            {fundingPartner.slice(1).map((fundingPartner,index) => (
                            <MenuItem
                                value={fundingPartner.id}
                                key={index}
                            >
                                {fundingPartner.funding_partner_name}
                            </MenuItem>
                        ))}                        
                        </Select>                    
                    </FormControl>
                )}
            </Grid>
            <Grid container  item lg={12} md={12} sm={12} xs={12} mt={2}>
                <Card sx={{background: 'linear-gradient(to bottom, #DFECFF, #FFFFFF)',borderRadius:"20px",boxShadow:"none",width:"100%",padding:'2% 4%'}}>
                    <CardContent>
                        <Grid container  item lg={12} md={12} sm={12} xs={12} display={"flex"} justifyContent={"space-between"}>
                            <Grid item lg={6} md={6} sm={7} xs={7} display={"flex"} alignItems={"center"}>
                                <Typography variant={isMobile?"h6":"h5"} color={"#2E67BC"}><b>About {fundingPartnerDetail.funding_partner_name}</b></Typography>
                            </Grid>
                            <Grid item lg={6} md={6} sm={5} xs={5} sx={{textAlign:"right"}}>
                                <img src={`${config.BACKEND_URL}${fundingPartnerDetail.brand_logo}`} style={{width:"auto",height:isMobile?"30px":"60px"}} />
                            </Grid>
                        </Grid>
                        <Grid container  item lg={12} md={12} sm={12} xs={12}>
                            <Typography variant={isMobile?"body2":"body1"}>{fundingPartnerDetail.partner_info}</Typography>
                        </Grid>
                       
                        <Grid container  item lg={12} md={12} sm={12} xs={12} mt={1}>
                             {fundingPartnerData != 1 && (
                            <Card sx={{backgroundColor:"#2E67BC",borderRadius:"15px",boxShadow:"none",width:"100%",marginBottom:'2%'}}>
                                <CardContent>
                                    <Grid container  item lg={12} md={12} sm={12} xs={12} display={"flex"} justifyContent={"center"}>
                                        <Typography color={"white"} variant={isMobile?"body1":"h5"} textAlign={"center"} fontWeight={"bold"}>Businesses Run On Funding. Get Paid For Supplying It.</Typography>
                                    </Grid>
                                    <Grid container  item lg={12} md={12} sm={12} xs={12} display={"flex"} justifyContent={"center"}>
                                        <Typography color={"white"} variant={isMobile?"body1":"h6"} textAlign={"center"} fontWeight={"bold"} onClick={() => window.open(fundingPartnerDetail.affiliate_registration_link, '_blank')} sx={{cursor:"pointer"}}><u>Join As An Affiliate Today!</u></Typography>
                                    </Grid>
                                </CardContent>
                            </Card>
                            )}
                        </Grid>
                        <Grid container  item lg={12} md={12} sm={12} xs={12} >
                            <Card sx={{background: 'white',borderRadius:"20px",boxShadow:"none",width:"100%"}}mt={2}>
                                <CardContent>
                                    <Grid container  item lg={12} md={12} sm={12} xs={12} display={"flex"} justifyContent={"space-between"}>
                                        <Stack direction={isMobile?"column":"row"} spacing={2} width={"100%"}>
                                            <Grid item lg={6} md={6} sm={12} xs={12}  display={"flex"} justifyContent={"center"}>
                                                <Grid container  item lg={12} md={12} sm={12} xs={12}>
                                                    <Stack direction={isMobile?"column":"row"} width={"100%"}>
                                                        <Grid item lg={3} md={3} sm={12} xs={12} mt={isMobile?1:0}>
                                                            <Typography variant="body1"><b>Contact Us:</b></Typography>
                                                        </Grid>
                                                        <Grid item lg={9} md={9} sm={12} xs={12}>
                                                            <Grid container  item lg={12} md={12} sm={12} xs={12} mt={isMobile?2:0}>
                                                                <Typography variant="body1" sx={{display:"flex",alignItems:"center",fontWeight:"bold"}}><img src={require("../../../assets/icons/phone.png")} style={{width:"20px"}}/>&nbsp;&nbsp; {fundingPartnerDetail.phone_no}</Typography>
                                                            </Grid>
                                                            <Grid container  item lg={12} md={12} sm={12} xs={12} mt={isMobile?2:1}>
                                                                <Typography variant="body1" sx={{display:"flex",alignItems:"center",fontWeight:"bold",overflowWrap:'anywhere'}}><img src={require("../../../assets/icons/mail.png")} style={{width:"20px"}}/>&nbsp;&nbsp; <u> {fundingPartnerDetail.contact_email}</u></Typography>
                                                            </Grid>
                                                        </Grid>
                                                    </Stack>
                                                </Grid>
                                            </Grid>
                                            <Grid item lg={6} md={6} sm={12} xs={12}  display={"flex"} justifyContent={"center"}>
                                                <Grid container  item lg={12} md={12} sm={12} xs={12}>
                                                    <Stack direction={isMobile?"column":"row"} width={"100%"} >
                                                        <Grid item lg={3} md={3} sm={12} xs={12} mt={isMobile?1:0}>
                                                            <Typography variant="body1"><b>Our Policies:</b></Typography>
                                                        </Grid>
                                                        <Grid item lg={9} md={9} sm={12} xs={12} mt={isMobile?1:0}>

                                                            {fundingPartnerDetail?.links?.length > 0 && fundingPartnerDetail.links.map((item, index) => (
                                                                <Grid container item lg={12} md={12} sm={12} xs={12} key={index} mt={isMobile?2:1}>
                                                                    <Typography
                                                                    variant="body1"
                                                                    sx={{
                                                                        color: "#2E67BC",
                                                                        display: "flex",
                                                                        alignItems: "center",
                                                                        fontWeight: "bold",
                                                                        cursor: "pointer"
                                                                    }}
                                                                    onClick={() => window.open(item.link, '_blank')}
                                                                    >
                                                                    <img
                                                                        src={`${config.BACKEND_URL}${item.icon}`}
                                                                        style={{ width: "20px" }}
                                                                        alt={item.link_name}
                                                                    />
                                                                    &nbsp;&nbsp; <u>{item.link_name}</u>
                                                                    </Typography>
                                                                </Grid>
                                                            ))}
                                                        </Grid>
                                                    </Stack>
                                                </Grid>
                                            </Grid>
                                        </Stack>
                                    </Grid>
                                </CardContent>
                            </Card>  
                        </Grid>
                </CardContent>
                </Card>  
            </Grid>
            </>
        )
    }
    return (
        <div>
            <DefaultLayout content={<ContentLayout />} />
           <div>
                <Backdrop
                    sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                    open={freez}
                    // onClick={handleFreezStop}
                >
                    <Freez />
                </Backdrop>
            </div>
        </div>
    );

}

export default FundingShotInfo;